/*
      Basic form checkbox
 */
import React, { useEffect, useState } from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

const getFormControlClass = (size) => {
   return size === 'small'
      ? 'MuiFormControlLabel-size-small'
      : '';
};

const CheckboxWithLabel = ({
   value,
   onChange,
   label,
   labelPlacement,
   size,
   className,
   id,
   disabled,
}) => {
   const [formControlClass, setFormControlClass] = useState(getFormControlClass(size));

   useEffect(() => {
      setFormControlClass(getFormControlClass(size));
   }, [size]);

   return (
      <>
         <FormControlLabel
            className={ formControlClass }
            control={(
               <Checkbox
                  checked={ value }
                  onChange={ onChange }
                  size={ size }
                  className={ className }
                  id={ id }
                  disabled={disabled}
               />
            )}
            label={ label }
            labelPlacement={ labelPlacement }
         />
      </>
   );
};

const CheckboxWithoutLabel = ({
   value,
   onChange,
   size,
   className,
   id,
   disabled,
}) => {
   return (
      <Checkbox
         checked={ value }
         onChange={ onChange }
         size={ size }
         className={ className }
         id={ id }
         disabled={disabled}
      />
   );
};

const UpwardCheckbox = (props) => {
   if (props.label) {
      return (<CheckboxWithLabel { ...props } />);
   } else {
      return (<CheckboxWithoutLabel { ...props }/>);
   }
};

UpwardCheckbox.propTypes = {
   value: PropTypes.bool,
   onChange: PropTypes.func,
   label: PropTypes.string,
   labelPlacement: PropTypes.string,
   size: PropTypes.string,
   required: PropTypes.bool,
   className: PropTypes.string,
   id: PropTypes.string,
};

UpwardCheckbox.defaultProps = {
   value: false,
   onChange: null,
   label: undefined,
   labelPlacement: 'end', // 'end' | 'start' | 'bottom' | 'top'
   size: 'small', // 'small' | 'medium'
   required: false,
   className: '',
   id: undefined,
};

export default UpwardCheckbox;
